import React from 'react';
export function Footer() {
  return <footer className="bg-black py-10 px-4 text-center border-t border-white/5" data-id="element-83">
      <div className="container mx-auto" data-id="element-84">
        <p className="text-[#d4a017]/60 text-xs tracking-[0.3em] uppercase mb-3" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-85">
          Formación Integral
        </p>
        <h3 className="text-xl font-serif font-bold text-white mb-5" data-id="element-86">
          BIODECODIFICACION · Comprende · Sana
        </h3>
        <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-6 mb-6 text-sm text-[#d4a017]/50" data-id="element-87">
          <a href="#" className="hover:text-[#d4a017] transition-colors" data-id="element-88">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-[#d4a017] transition-colors" data-id="element-89">
            Política de Privacidad
          </a>
        </div>
        <p className="text-xs text-gray-500 max-w-lg mx-auto leading-relaxed" data-id="element-90">
          © 2025 Academia Holística Argentina. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}